export function IconArrow() {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M14.552 11.2163L10.5695 6.12483C10.439 5.95811 10.2278 5.95839 10.0975 6.12569C9.96737 6.29297 9.96771 6.56395 10.0982 6.7308L13.8436 11.5192L10.0981 16.3077C9.96759 16.4745 9.96725 16.7453 10.0974 16.9126C10.1627 16.9965 10.2482 17.0384 10.3338 17.0384C10.4191 17.0384 10.5043 16.9968 10.5695 16.9135L14.552 11.8221C14.6149 11.742 14.6501 11.6329 14.6501 11.5192C14.6501 11.4056 14.6148 11.2966 14.552 11.2163Z"
                fill="#323232"/>
        </svg>
    )
}